import { useEffect } from "react";

/**
 * Adjusts for iOS keyboard by setting --keyboard-offset CSS variable.
 * Instead of resizing the whole layout (which breaks navigation),
 * this only tracks the keyboard offset for input positioning.
 */
export function useViewportHeight() {
  useEffect(() => {
    const update = () => {
      const vv = window.visualViewport;
      if (!vv) return;
      // Keyboard offset = difference between layout viewport and visual viewport
      const keyboardOffset = window.innerHeight - vv.height;
      document.documentElement.style.setProperty(
        "--keyboard-offset",
        `${keyboardOffset}px`,
      );
    };

    update();
    window.visualViewport?.addEventListener("resize", update);
    window.visualViewport?.addEventListener("scroll", update);

    return () => {
      window.visualViewport?.removeEventListener("resize", update);
      window.visualViewport?.removeEventListener("scroll", update);
    };
  }, []);
}
